module.exports = __webpack_public_path__ + "static/media/dynamic wallet -  white.77e76b3b.svg";